module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "binding"
  }, [_c('mt-header', {
    attrs: {
      "title": "账号绑定"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bindingWrap phone"
  }, [_c('div', {
    staticClass: "phoneIcon"
  }, [_c('icon', {
    attrs: {
      "name": "mobile"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn successBtn"
  }, [_vm._v("已绑定>")])]), _vm._v(" "), _c('div', {
    staticClass: "bindingWrap wx"
  }, [_c('div', {
    staticClass: "wxIcon"
  }, [_c('icon', {
    attrs: {
      "name": "weixin"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("未绑定>")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("手机账号绑定")]), _vm._v(" "), _c('p', [_vm._v("136*****321")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("微信登录绑定")]), _vm._v(" "), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35cea8e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/binding.vue
// module id = 1272
// module chunks = 1